// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".errorMessage-root-uB8 {\n}\n\n.errorMessage-errorMessage-pas {\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "errorMessage-root-uB8",
	"errorMessage": "errorMessage-errorMessage-pas font-semibold leading-normal text-error text-sm"
};
export default ___CSS_LOADER_EXPORT___;
